<template>
  <div class="font_16" style="height:100%;width:100%;overflow:hidden auto;">
    <el-container>
      <el-main style="padding: 5% 20px 0 20px;">
        <el-row class="font_16">
          ユーザーのパスワードをリセットできます。
        </el-row>
        <el-row style="margin:1em 0 1em 0;width:100%;justify-content: center;">
          <p class="font_14" style="width:350px;">
            メールアドレスを入力して、送信ボタンをクリックしてください。入力したメールアドレスに確認コードが送信されます。
          </p>
        </el-row>
        <el-row style="justify-content:center;">
          <div style="max-width:350px;min-width:200px;">
            <el-form ref="formCodeRef" :model="formCode" :rules="rulesCode" label-position="top"
              style="max-width:350px;min-width:200px;" @submit.prevent>
              <el-form-item label="農家ID" prop="farmerId">
                <el-input class="font_18" v-model="formCode.farmerId" :maxlength="64"
                  style="max-width:335px;min-width:185px;" />
              </el-form-item>
              <el-form-item label="メールアドレス" prop="email" style="padding-top:0.5em;">
                <el-input class="font_18" type="email" v-model="formCode.email" :maxlength="maxLength"
                  style="max-width:335px;min-width:185px;" />
              </el-form-item>
              <el-row style="justify-content:center;width:100%;padding-top:1em;">
                <el-button class="button-style" color="#ffdf5e" type="primary" @click="click_forgot_password"
                  style="margin-left: 10px;">
                  送信
                </el-button>
              </el-row>
            </el-form>
            <el-form ref="formRef" :model="form" :rules="rules" label-position="top"
              style="max-width:350px;min-width:200px;" @submit.prevent>
              <div style="margin-top:40px;">
                <p class="font_14">メールアドレスに届いた確認コードと変更後のパスワードを入力してください。</p>
                <el-form-item label="確認コード" prop="confirmationCode">
                  <el-input class="font_18" v-model="form.confirmationCode" :maxlength="maxLength"
                    style="max-width:335px;min-width:185px;" />
                </el-form-item>
                <el-form-item label="変更後のパスワード" prop="newPassword1" style="padding-top:0.5em;position:relative;">
                  <el-input class="font_18" v-model="form.newPassword1" type="password" :suffix-icon="IconEyeSlash"
                    autocomplete="new-password" :minlength="8" :maxlength="maxLength"
                    style="max-width:335px;min-width:185px;" v-if="!showPassword1" />
                  <el-input class="font_18" v-model="form.newPassword1" :suffix-icon="IconEye" autocomplete="new-password"
                    :minlength="8" :maxlength="maxLength" style="max-width:335px;min-width:185px;" v-if="showPassword1" />
                  <div style="width:0px;height:50px;position:relative;">
                    <el-button class="btn-height" type="primary" @click="showPassword1 = !showPassword1"
                      style="position:absolute;left:-33px;height:50px;top:0px;opacity: 0;" />
                  </div>
                </el-form-item>
                <el-form-item label="変更後のパスワード（確認）" prop="newPassword2" style="padding-top:0.5em;position:relative;">
                  <el-input class="font_18" v-model="form.newPassword2" type="password" :suffix-icon="IconEyeSlash"
                    autocomplete="new-password" :minlength="8" :maxlength="maxLength"
                    style="max-width:335px;min-width:185px;" v-if="!showPassword2" />
                  <el-input class="font_18" v-model="form.newPassword2" :suffix-icon="IconEye" autocomplete="new-password"
                    :minlength="8" :maxlength="maxLength" style="max-width:335px;min-width:185px;" v-if="showPassword2" />
                  <div style="width:0px;height:50px;position:relative;">
                    <el-button class="btn-height" type="primary" @click="showPassword2 = !showPassword2"
                      style="position:absolute;left:-33px;height:50px;top:0px;opacity: 0;" />
                  </div>
                </el-form-item>
              </div>

              <el-row v-if="message" class="font_12" style="color:#F56C6C;padding-top:1em;">{{ message }}</el-row>

              <el-row class="font_12 text-center">
                <p>[パスワードポリシー]<br>
                  ・パスワードは8文字以上入力してください。<br>
                  ・数字、英大文字、英小文字を1文字以上含めてください。<br>
                  ・以下の特殊文字のいずれか1文字以上を含めてください。<br>
                  特殊文字： ^$*.[]{}()?-&quot;!@#%&amp;/\,&gt;&lt;&#39;:;|_~`+=</p>
              </el-row>
            </el-form>
          </div>
        </el-row>
        <el-row style="justify-content:center;width:100%;margin-bottom:1em;">
          <el-button class="button-style" color="#ffdf5e" type="primary" @click="click_reset_password">
            変更
          </el-button>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { ElMessageBox } from 'element-plus'
import { CognitoUserAccessor } from "@/views/js/cognito-login"
import ConstParam from '../views/js/const';
import { shallowRef } from 'vue';
import * as icons from '../components/icons/modules'

export default {
  emits: ['updateUsers'],
  data() {
    return {
      showPassword1: false,
      showPassword2: false,
      IconEye: shallowRef(icons.IconEye),
      IconEyeSlash: shallowRef(icons.IconEyeSlash),
      IconQuestion: shallowRef(icons.IconQuestion),
      maxLength: ConstParam.maxLength,
      message: '',
      formCode: {
        farmerId: '',
        email: '',
      },
      form: {
        confirmationCode: '',
        newPassword1: '',
        newPassword2: '',
      },
      rulesCode: {
        farmerId: [
          { required: true, message: 'この項目は入力が必須です。' },
          { pattern: /^[0-9a-z\-_]+$/, message: '数字、英字小文字、アンダースコア (_)、ハイフン (-) のみで入力してください。', trigger: 'blur' },
          { max: 64, message: '64文字以下で入力してください。' },
        ],
        email: [
          { required: true, message: 'この項目は入力が必須です。', },
          { type: 'email', message: 'メールアドレスの形式が間違っています。', trigger: 'blur' },
          { max: this.maxLength, message: this.maxLength + '文字以下で入力してください。' },
        ],
      },
      rules: {
        confirmationCode: [
          { required: true, message: 'この項目は入力が必須です。', },
          { min: 6, message: '6文字で入力してください。' },
          { max: 6, message: '6文字で入力してください。' },
          { pattern: /^[0-9]{6}$/, message: '数字6桁で入力してください。', trigger: 'blur' },
        ],
        newPassword1: [
          { required: true, message: 'この項目は入力が必須です。' },
          { min: 8, message: '8文字以上で入力してください。' },
          { max: this.maxLength, message: this.maxLength + '文字以下で入力してください。' },
          { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[=+\-^$*.[\]{}()?"!@#%&/\\,><':;|_~`])\S+$/, message: '大文字・小文字・数字、特殊文字をそれぞれ１文字以上含む必要があります。' },
        ],
        newPassword2: [
          { required: true, message: 'この項目は入力が必須です。' },
          { min: 8, message: '8文字以上で入力してください。' },
          { max: this.maxLength, message: this.maxLength + '文字以下で入力してください。' },
          { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[=+\-^$*.[\]{}()?"!@#%&/\\,><':;|_~`])\S+$/, message: '大文字・小文字・数字、特殊文字をそれぞれ１文字以上含む必要があります。' },
        ],
      },
    }
  },
  methods: {
    passwordMessage(message) {
      this.$alert(message, "", {
        confirmButtonText: 'もう一度実行'
      }).catch(() => {
        return
      });
    },
    viewMessage(message) {
      ElMessageBox.alert(message, '', {})
    },
    click_forgot_password() {
      this.message = "";
      this.$refs.formCodeRef.validate((valid) => {
        if (!valid) {
          this.message = '赤枠表示部分の入力内容を修正してください。'
          return
        }
        CognitoUserAccessor.forgotPassword(this.formCode.farmerId + '@' + this.formCode.email)
          .then(() => {
            this.sendedCode = true
            this.viewMessage('指定されたメールアドレスへ確認コードを送信しました。');
          })
          .catch(err => {
            console.log(err)
            this.message = `確認コード送信に失敗しました。(${err.message})`
          })
      })
    },
    click_reset_password() {
      this.message = "";
      this.$refs.formCodeRef.validate((valid) => {
        if (!valid) {
          this.message = '赤枠表示部分の入力内容を修正してください。'
          return
        }
      })
      if (this.form.newPassword1 !== this.form.newPassword2) {
        this.message = '変更後のパスワードと変更後のパスワード（確認）が一致しません。'
        return
      }
      const re = new RegExp(ConstParam.password_reg)
      if (!re.test(this.form.newPassword1)) {
        this.passwordMessage(ConstParam.password_error)
        return
      }
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          this.message = '赤枠表示部分の入力内容を修正してください。'
          return
        }
        const username = this.formCode.farmerId + '@' + this.formCode.email
        CognitoUserAccessor.resetPassword(username, this.form.newPassword1, this.form.confirmationCode)
          .then(() => {
            this.viewMessage('パスワードをリセットしました。');
            this.$refs.formRef.resetFields()
            this.message = ''
            this.$router.push('/phonereturnapplication')
          })
          .catch(err => {
            this.viewMessage(`パスワードのリセットに失敗しました。(${err.message})`);
          })
      })
    },
  },
}
</script>

<style scoped>
.icon {
  color: #555553;
  width: 1.25em;
  height: 1.25em;
  padding: 0.3em 1em;
}

.dialog-footer button:first-child {
  margin-right: 10px;
}

.el-input {
  width: 100%;
  height: 50px;
}

.el-dialog {
  min-width: 500px;
}
</style>